import React from 'react';
import SidebarItem from './SidebarItem';

function SidebarSection({ title, items, isActive, onNavigate }) {
  return (
    <section className="mp-sidebar-section">
      <h4 className="mp-sidebar-section__title">{title}</h4>
      <div className="mp-sidebar-section__items">
        {items.map((item) => (
          <SidebarItem
            key={item.label}
            icon={item.icon}
            label={item.label}
            active={isActive(item.path)}
            onClick={() => onNavigate(item.path)}
          />
        ))}
      </div>
    </section>
  );
}

export default SidebarSection;
